import React from 'react';
import {FunctionField, Show, Tab, TabbedShowLayout, TextField, useRecordContext, useRedirect} from 'react-admin';
import GradientButton from "../../../Component/Layouts/Button/GradientButton";

export const DownloadSettingsShow = () => {
    const redirect = useRedirect();

    const navigateToEdit = () => {
        redirect(`/downloads/settings/custom/edit`)
    }

    const InfoShowTab = () => {
        const record = useRecordContext();
        if (!record) return null;

        return (
            <TabbedShowLayout>
                <Tab label="Details">
                    <div>
                        <GradientButton style={{float: 'right'}} label={'Edit'} onClick={() => navigateToEdit()}/>
                    </div>
                    <FunctionField label="Limit enabled:" render={(record) => {
                        return record.enabled ? 'On' : 'Off';
                    }}/>
                    <TextField label='Maximum downloads:' source="maxDownloads"/>
                    <TextField label='Warning at:' source="warningAt"/>
                    <FunctionField label="Enforcement date:" render={(record) => {
                        return record.enforcementDate || '-';
                    }}/>
                </Tab>
            </TabbedShowLayout>
        );
    };

    return (
        <>
            <Show actions={<></>}>
                <InfoShowTab/>
            </Show>
        </>
    );
};
